"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGridSection = void 0;
var react_1 = __importDefault(require("react"));
var DataGridSection = function (props) {
    return (react_1.default.createElement("div", { style: { backgroundColor: 'white', padding: '0.625rem 0' } },
        react_1.default.createElement("div", { className: "container-fluid" }, props.children)));
};
exports.DataGridSection = DataGridSection;
//# sourceMappingURL=DataGridSection.js.map